// Note this function orders objects by their indices. Objects without an index key will preceed those with.
// ie all "non-indexed" objects will be added before "indexed" ones..
export const compareObjectIndices = (a, b) => {
  if (isObject(a) && isObject(b)) {
    if (hasValidIndex(a)) {
      if (hasValidIndex(b)) {
        if (a.index > b.index) {
          return 1;
        } else if (a.index < b.index) {
          return -1;
        } else {
          return 0;
        }
      } else {
        return 1;
      }
    } else if (hasValidIndex(b)) {
      return -1;
    } else {
      return 0;
    }
  } else {
    console.error(
      `Error in helper-function.js -> compareObjectIndices: invalid arguments. Args: ${a}, ${b}`
    );
    return 0;
  }
};

export const getSandboxOptions = function (url) {
  // used in the iframe and embed elements
  if (url && typeof url === 'string') {
    const embedSandboxExemptions = [
      'airtable',
      'emf',
      'qualtrics',
      'mailchi',
      'tableau',
      'slides',
      'vimeo',
      'spotify',
      'sites',
    ];

    let sandboxExceptionNeccesary = false;

    embedSandboxExemptions.forEach(sandboxExemption => {
      if (url.search(sandboxExemption) !== -1) {
        sandboxExceptionNeccesary = true;
      }
    });

    let sandboxOptions = `allow-forms allow-scripts allow-popups allow-downloads allow-popups-to-escape-sandbox ${
      sandboxExceptionNeccesary ? 'allow-same-origin' : ''
    }`;

    return sandboxOptions;
  } else {
    console.warn(
      `getSandboxOptions in helper-functions.js was passed non-valid props: ${url} `
    );

    return null;
  }
};

export const hasValidIndex = object => {
  if (isObject(object)) {
    return (
      'index' in object && typeof object.index === 'number' && object.index >= 0
    );
  } else {
    console.warn(
      `helper-functions.js -> hasValidIndex passed invalid argument: ${object}`
    );
    return false;
  }
};

export const isObject = variable => {
  return (
    typeof variable === 'object' &&
    !Array.isArray(variable) &&
    variable !== null
  );
};

export const normalizeTrailingSlash = url => {
  return url.replace(/\/+$/, '');
};
